/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Not_Found_Back_HomeInputs */

const en_common_not_found_back_home = /** @type {(inputs: Common_Not_Found_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const zh_common_not_found_back_home = /** @type {(inputs: Common_Not_Found_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Common_Not_Found_Back_HomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_not_found_back_home = /** @type {((inputs?: Common_Not_Found_Back_HomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Not_Found_Back_HomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_not_found_back_home(inputs)
	return zh_common_not_found_back_home(inputs)
});
export { common_not_found_back_home as "common.not_found.back_home" }